import { useEffect } from 'react';
import classNames from 'classnames';
import {
  Outlet,
  useLocation,
  useNavigate,
  useOutletContext,
} from 'react-router-dom';

import { manageRequestActions } from '@Features/store/ManageRequestSlice';
import { PresentationRequestHeader } from '@Components/index';
import { Can } from '@Components/Can';
import { useAppDispatch, useResizeLayout } from '@Hooks/index';
import { MButton } from '@Components/Base';
import { ReactComponent as PlusAddIcon } from '@Icons/additional/plus-add.svg';

import styles from './manage-requests.module.css';

const ManageRequests: React.FC = () => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const { isRequestFormPage } = useOutletContext<{
    isRequestFormPage: boolean;
  }>();

  const { isMobile } = useResizeLayout();

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(manageRequestActions.setSelectedRequest('Request'));
  }, []);

  return (
    <>
      {!isRequestFormPage && (
        <PresentationRequestHeader
          caption="My Requests"
          showSelect={false}
          requestType="MR"
        >
          <Can I="Create" a="Material">
            <MButton
              onClick={() => {
                navigate(`${pathname}/create`);
              }}
              type="primary"
              className={classNames(
                styles.addNewRequestButton,
                isMobile ? styles.mobileButton : ''
              )}
            >
              <div>
                <PlusAddIcon />
              </div>
              Add
            </MButton>
          </Can>
        </PresentationRequestHeader>
      )}
      <Outlet context={{ isRequestFormPage }} />
    </>
  );
};

export default ManageRequests;
